<div id="container1" class="container"></div>
<div #serieProposalModal class="serie-proposal-modal" *ngIf="serieProposal">
  <!-- Page Header -->
  <div class="modal-header sale-modal">
    <div class="d-flex justify-content-between w-100 pe-3 align-items-start">
      <h2 class="modal-title">
        {{ 'serieProposalModule.serieProposal' | translate }}:
        {{ (productEntities$ | async)[serieProposal.productId]?.description }}
        -
        {{
          (memberEntities$ | async)[serieProposal?.customerPersonId]?.firstName
        }}
        {{
          (memberEntities$ | async)[serieProposal?.customerPersonId]?.lastName
        }}
      </h2>
    </div>

    <button
      data-test-id="booking-show-modal-close-button"
      type="button"
      class="btn-close"
      attr.aria-label="{{ 'general.close' | translate }}"
      (click)="cancel()"
    ></button>
  </div>
  <!-- End Page Header -->

  <div class="modal-body booking-modal-content-wrapper py-0">
    <nav attr.aria-label="{{ 'wcag.serieProposalMenu' | translate }}">
      <ul
        class="nav nav-tabs align-items-center mb-3"
        *ngIf="serieProposal"
        role="tablist"
      >
        <!-- WCAG SKIP link -->
        <!-- <li class="nav-item">
          <a
            href="#serieProposalModal"
            class="nav-link visually-hidden-focusable"
            ><span>{{ 'wcag.skipNavigation' | translate }}</span></a
          >
        </li> -->
        <!-- END WCAG skip link -->
        <li class="nav-item">
          <a
            href="javascript:;"
            class="nav-link"
            (click)="activeTab = 'general'"
            [ngClass]="{
              active: activeTab == 'general'
            }"
            role="tab"
            [attr.aria-selected]="activeTab == 'general' ? 'true' : 'false'"
            aria-controls="panel-general"
          >
            <i role="img" class="fa me-1 fa-cube" aria-hidden="true"></i>
            {{ 'general.general' | translate }}
          </a>
        </li>

        <li class="nav-item">
          <a
            href="javascript:;"
            class="nav-link"
            (click)="activeTab = 'serie'"
            [ngClass]="{
              active: activeTab == 'serie'
            }"
            role="tab"
            [attr.aria-selected]="activeTab == 'serie' ? 'true' : 'false'"
            aria-controls="panel-serie"
          >
            <i role="img" class="fa me-1 fa-stream" aria-hidden="true"></i>
            {{ 'serieProposalModule.serie' | translate }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <!-- End Nav -->

  <div class="modal-body pt-0" id="serieProposalModal">
    <serie-proposal-general-tab
      *ngIf="activeTab == 'general'"
      [serieProposalId]="serieProposal.id"
      [isModal]="true"
      (onCloseModal)="cancel()"
      [fromInitialRequest]="true"
      id="panel-general"
    ></serie-proposal-general-tab>

    <serie-proposal-series-tab
      *ngIf="activeTab == 'serie'"
      [serieProposalId]="serieProposal.id"
      [fromInitialRequest]="true"
      id="panel-serie"
    ></serie-proposal-series-tab>
  </div>
</div>
